import { render, staticRenderFns } from "./VacationRequestDetails.vue?vue&type=template&id=f72524c6&scoped=true&"
import script from "./VacationRequestDetails.vue?vue&type=script&lang=js&"
export * from "./VacationRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequestDetails.vue?vue&type=style&index=0&id=f72524c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72524c6",
  null
  
)

export default component.exports